// extracted by mini-css-extract-plugin
export default {"spinnerSvg":"Spinner_spinnerSvg__wRtv+","spin":"Spinner_spin__YNgFg"};